
import { mapGetters, mapState } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
import ChannelOnlineStatusHandler from "../reciever/channel-online-status-handler.vue";

export default {
  components: { ResponsiveDialog, ChannelOnlineStatusHandler },

  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("restaurant", [
      "getAllBrands",
      "hasMultipleBrands",
      "getLocationChannels"
    ]),
    ...mapState("restaurant", ["locationDetails"])
  },
  data() {
    return {
      selectedBrand: {}
    };
  },
  beforeMount() {
    this.selectedBrand = this.getAllBrands[0];
  },
  methods: {
    handleBrandClick(id) {
      this.selectedBrand = this.getAllBrands.find((el) => el.id === id);
    },
    addAnotherBrand() {
      this.$emit("show-add-brand-dialog");
    },
    handleAddNewChannel() {
      this.$emit("close-dialog");
      this.$router.push("/settings/channel-manager");
    }
  }
};
